import styled from '@emotion/styled'

export const ExciseSelectWrapper = styled.div`
  width: 113px;
`
